var path = 'src/app/components/technical/information-bar/information-bar.template.html';
var html = "<div class=\"information-bar\" ng-if=\"$ctrl.message\">\n  <h2>System information</h2>\n  {{$ctrl.message}}\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;